import { SSOApi } from 'shared/api';
import { IChangePassword } from 'shared/api/sso/interfaces/sso.interfaces';

export const passwordChange = async (dto: IChangePassword) => {
  await SSOApi.changePassword(dto);
};
